import { Preferences } from '@capacitor/preferences'

const TOKEN_KEY = 'abilibee-token'
let tokenPromise: Promise<string | null> | null = null

const getToken = async () => {
  if (!tokenPromise) {
    tokenPromise = (async () => {
      try {
        const { value } = await Preferences.get({ key: TOKEN_KEY })
        return value
      } catch (error) {
        console.error('Error getting token:', error)
        return null
      }
    })()
  }
  return tokenPromise
}

export default getToken
